//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { verifyPhone, verifyId, verifyId_HUZHAO, verifyId_GANGAO, verifyId_TAIBAO } from '@/utils/validate';
export default {
  props: {
    needRealName: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.form.buyer_name = this.$localStore.get('buyer_name') || '';
    this.form.buyer_phone = this.$localStore.get('buyer_phone') || '';
    this.form.buyer_identify = this.$localStore.get('buyer_identify') || '';
    this.form.buyer_papers_type = this.$localStore.get('buyer_papers_type') || 'ID_CARD';
  },
  data: function data() {
    return {
      type: 'add',
      visible: false,
      form: {
        buyer_name: '',
        buyer_identify: '',
        buyer_phone: '',
        buyer_papers_type: 'ID_CARD'
      },
      contacts: [],
      options: [{
        value: 'ID_CARD',
        label: '身份证'
      }, {
        value: 'HUZHAO',
        label: '护照'
      }, {
        value: 'GANGAO',
        label: '港澳通行证'
      }, {
        value: 'TAIBAO',
        label: '台湾通行证'
      }],
      validateList: {
        'ID_CARD': verifyId,
        'HUZHAO': verifyId_HUZHAO,
        'GANGAO': verifyId_GANGAO,
        'TAIBAO': verifyId_TAIBAO
      }
    };
  },
  methods: {
    verifyId: verifyId,
    verifyPhone: verifyPhone,
    show: function show(item) {
      this.visible = true;
    },
    onSubmit: function onSubmit(values) {
      var _this = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        var _this$form = _this.form,
            buyer_name = _this$form.buyer_name,
            buyer_identify = _this$form.buyer_identify,
            buyer_phone = _this$form.buyer_phone,
            buyer_papers_type = _this$form.buyer_papers_type;
        buyer_name && _this.$localStore.set('buyer_name', buyer_name);
        buyer_phone && _this.$localStore.set('buyer_phone', buyer_phone);
        buyer_identify && _this.$localStore.set('buyer_identify', buyer_identify);
        buyer_papers_type && _this.$localStore.set('buyer_papers_type', buyer_papers_type);

        _this.$emit('complete', _this.form);

        _this.visible = false;
      });
    }
  }
};